import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import Maps from '../components/maps';

const geocoderSuccess = (results, status, position, successCallback, errorCallback) => {
  if (status === google.maps.GeocoderStatus.OK) {
    let city = '';
    let region = '';
    let name = '';
    const geocodeResult = results[0];
    for (let i = 0; i < geocodeResult.address_components.length; i += 1) {
      if (geocodeResult.address_components[i].types[0] === 'locality') {
        city = geocodeResult.address_components[i];
      }
      if (geocodeResult.address_components[i].types[0] === 'administrative_area_level_1') {
        region = geocodeResult.address_components[i];
      }
    }
    name = `${city.long_name}, ${region.short_name}`;
    if ($.isFunction(successCallback)) {
      successCallback(position.coords.latitude, position.coords.longitude, name);
    }
  }
};

const getCurrentPositionSuccess = (position, successCallback, errorCallback) => {
  Maps.addHandler(() => {
    const geocoder = new google.maps.Geocoder();
    const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      geocoderSuccess(results, status, position, successCallback, errorCallback);
    });
  });
};

const getCurrentPositionError = (error, successCallback, errorCallback) => {
  let msg = '';
  switch (error.code) {
    case error.PERMISSION_DENIED:
      msg = 'PERMISSION_DENIED';
      break;
    case error.POSITION_UNAVAILABLE:
      msg = 'POSITION_UNAVAILABLE';
      break;
    case error.TIMEOUT:
      msg = 'TIMEOUT';
      break;
    default:
      msg = 'UNKNOWN_ERROR';
      break;
  }
  if ($.isFunction(errorCallback)) {
    errorCallback(msg);
  }
};

export default (successCallback, errorCallback) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      position => {
        getCurrentPositionSuccess(position, successCallback, errorCallback);
      },
      error => {
        getCurrentPositionError(error, successCallback, errorCallback);
      }
    );
  } else if ($.isFunction(errorCallback)) {
    errorCallback('GEOLOCATION_UNSUPPORTED');
  }
};



// WEBPACK FOOTER //
// ./js/utilities/geoHTML5Lookup.js